<template>
    <div>
        <el-dropdown size="small" @command="handleCommand">
            <el-button type="primary">
                {{ levelLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="levelType === -1" command="1">设置核心专利</el-dropdown-item>
                <el-dropdown-item v-if="levelType === -1" command="2">设置重要专利</el-dropdown-item>
                <el-dropdown-item v-if="levelType === -1" command="3">设置一般专利</el-dropdown-item>
                <el-dropdown-item v-if="levelType !== -1" command="4">修改</el-dropdown-item>
                <el-dropdown-item v-if="levelType !== -1" command="5">删除</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <el-dialog
            title="修改分级"
            :visible.sync="dialogVisible"
            width="30%"
            append-to-body>
            <el-form ref="form" :model="dataForm" label-width="80px">
                <el-form-item label="选择分级">
                    <el-select v-model="dataForm.levelType" placeholder="请选择分级">
                        <el-option label="核心专利" :value="0"></el-option>
                        <el-option label="重要专利" :value="1"></el-option>
                        <el-option label="一般专利" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeLevel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            levelName: '未分级',
            levelType: -1,
            dialogVisible: false,
            dataForm: {
                levelType: 0
            }
        }
    },
    computed: {
        levelLabel: function() {
            this.getRecordLevel(this.data.ptNo);
            return this.levelName;
        },
        isLogin: function() {
            let user = localStorage.getItem('token');
            if (!user) {
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        async getRecordLevel(appno) {
            const { data: res } = await this.$http.get("ptlv/find/record/byno/10", {
                params: {
                    appno: appno
                },
            });
            if (res.code == 0) {
                this.levelType = res.data.levelType;
                this.dataForm.levelType = res.data.levelType;
                if (res.data.levelType === 0) {
                    this.levelName = "核心专利";
                } else if (res.data.levelType === 1) {
                    this.levelName = "重要专利";
                } else {
                    this.levelName = "一般专利";
                }
            } else {
            }
        },
        handleCommand(command) {
            console.log(command);
            if (!this.isLogin) {
                this.$message.error("无操作权限，请先注册用户!");
                return;
            }
            switch (command) {
                case '1':
                    this.setLevel(0);
                    break;
                case '2':
                    this.setLevel(1);
                    break;
                case '3':
                    this.setLevel(2);
                    break;
                case '4':
                    this.dialogVisible = true;
                    break;
                case '5':
                    this.deleteLevel();
                    break;
                default:
                    break;
            }
        },
        async deleteLevel() {
            const { data: res } = await this.$http.get("ptlv/remove/no/level/10", {
                params: {
                    appno: this.data.ptNo,
                    lv: this.levelType
                },
            });
            if (res.code == 0 && res.data) {
                this.$message.success("删除成功");
            } else {
                this.$message.error(res.msg);
            }
        },
        async changeLevel() {
            const { data: res } = await this.$http.get("ptlv/change/no/level/10", {
                params: {
                    appno: this.data.ptNo,
                    lv: this.dataForm.levelType
                },
            });
            if (res.code == 0 && res.data) {
                this.$message.success("修改成功");
                this.dialogVisible = false;
            } else {
                this.$message.error(res.msg);
            }
        },
        async setLevel(lv) {
            const { data: res } = await this.$http.post("ptlv/add/10", {
                applyNo: this.data.ptNo,
                levelType: lv
            });
            if (res.code == 0) {
                this.$message.success("设置成功");
            } else {
                this.$message.error(res.msg);
            }
        },
    }
}
</script>

<style scoped></style>